import type { PeticeOvmDto } from '@gov-nx/api';

export const petitionAddresseeTemplateResolver = (item: PeticeOvmDto) =>
	`${item.nazev} (${item.datovaSchrankaId})`;
